<template>
	<div class="indicator_blood_pressure_edit">
		<van-form>
			<div class="form_item">
				<van-cell title="记录档案" :value="params.patientName"></van-cell>
			</div>
			<div class="form_item">
				<van-field
					label="测量日期"
					input-align="right"
					:value="params.measureDate"
					readonly
					placeholder="请选择"
					is-link
					@click="pickerDateVisible = true"
				></van-field>
				<van-field
					label="测量时间"
					input-align="right"
					:value="params.measureTime"
					readonly
					placeholder="请选择"
					is-link
					@click="pickerTimeVisible = true"
				></van-field>
				<van-field
					type="number"
					label="甘油三酯"
					v-model="params.triglycerides"
					input-align="right"
					placeholder="请输入数值"
					@blur="numberHandle('triglycerides')"
				>
					<template #button>
						<span>mmol/L</span>
					</template>
				</van-field>
				<van-field
					type="number"
					label="低密度脂蛋白胆固醇"
					v-model="params.lowDensityFat"
					input-align="right"
					placeholder="请输入数值"
					@blur="numberHandle('lowDensityFat')"
				>
					<template #button>
						<span>mmol/L</span>
					</template>
				</van-field>
			</div>
		</van-form>

		<foot-button>
			<van-button color="#F5F6F7" block @click="clickDelete" v-if="$route.params.id">
				<span style="color: #1F2329;">删除</span>
			</van-button>
			<van-button type="primary" block @click="clickSubmit">保存</van-button>
		</foot-button>

		<!--日期-->
		<van-popup v-model="pickerDateVisible" position="bottom">
			<van-datetime-picker
				:value="params.measureDate || new Date()"
				type="date"
				title="选择日期"
				:formatter="$utils.vantDateTimePickerFormatter"
				:max-date="maxDate"
				@confirm="clickDatePickerConfirm"
				@cancel="pickerDateVisible = false"
			/>
		</van-popup>
		<!--时间-->
		<van-popup v-model="pickerTimeVisible" position="bottom">
			<van-datetime-picker
				:value="params.measureTime || $moment().format('HH:mm')"
				type="time"
				title="选择时间"
				:formatter="$utils.vantDateTimePickerFormatter"
				@confirm="clickTimePickerConfirm"
				@cancel="pickerTimeVisible = false"
			/>
		</van-popup>
	</div>
</template>

<script>
import MixinEdit from './mixins/edit'
export default {
    name: 'indicatorBloodPressure',
    mixins: [MixinEdit],
    data: () => ({
        params: {
            measureDate: '',
            measureTime: '',
            lowDensityFat: '',
            triglycerides: '',
            patientName: ''
        },
        maxDate: new Date()
    }),
    methods: {
        getApi (apiKey) {
            const apis = {
                saveApi: this.$api.indicator.saveBloodFatRecord,
                updateApi: this.$api.indicator.updateBloodFatRecord,
                deleteApi: this.$api.indicator.bloodFatDelete,
                detailApi: this.$api.indicator.bloodFatDetail
            }
            return apis[apiKey]
        },
        // 提交校验
        submitVerify () {
            const emptyItem = Object.entries(this.params).find(item => !item[1])
            if (emptyItem) {
                this.$toast(`请将数据填写完整`)
                return false
            }
            const lowDensityFat = Number.parseFloat(this.params.lowDensityFat)
            if (lowDensityFat < 0 || lowDensityFat > 15) {
                this.$toast(`低密度脂蛋白胆固醇值应在0~15范围内`)
                return false
            }
            const triglycerides = Number.parseFloat(this.params.triglycerides)
            if (triglycerides < 0 || triglycerides > 15) {
                this.$toast(`甘油三酯值应在0~15范围内`)
                return false
            }
            return true
        },
        numberHandle (key) {
            const val = this.params[key]
            if (val !== '') {
                this.$set(this.params, key, Number(val).toFixed(2))
            }
        }
    }
}
</script>

<style scoped lang="less">
.indicator_blood_pressure_edit {
	min-height: calc(100vh - 216px);
	padding: 40px 32px;
	.form_item {
		& + .form_item {
			margin-top: 38px;
		}
		border-radius: 16px;
		overflow: hidden;
	}
}
</style>
<style lang="less">
.indicator_blood_pressure_edit {
	.form_item {
		.van-cell {
			&::after {
				width: 100%;
			}
			padding-top: 32px;
			padding-bottom: 32px;
			.van-cell__title {
				width: 280px;
				font-family: PingFangSC-Medium;
				font-size: 30px;
				font-weight: normal;
				color: #1f2329;
			}
			.van-cell__value {
				font-family: PingFangSC-Regular;
				font-size: 30px;
				font-weight: normal;
				color: #1f2329;
			}
		}
	}
}
</style>
